'use client';

import { useTranslation } from '@/providers/I18nProvider';

interface Tool {
  id: string;
  name: string;
  description?: string;
  functionType: string;
  pipelineCustomFunctionsId?: string;
}

interface ToolsListProps {
  tools: Tool[];
  selectedTools: string[];
  onToggle: (toolId: string, enabled: boolean) => void;
}

export function ToolsList({ tools, selectedTools, onToggle }: ToolsListProps) {
  const { t } = useTranslation();
  
  if (tools.length === 0) {
    return (
      <div className="px-6 py-8 text-center text-gray-500 dark:text-gray-400">
        {t('admin.tools.empty.noTools')}
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-200">
      {tools.map((tool) => {
        const isEnabled = selectedTools.includes(tool.id);
        
        return (
          <div key={tool.id} className="px-6 py-4 flex items-center justify-between">
            <div className="flex-1">
              <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100">{tool.name}</h4>
              {tool.description && (
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{tool.description}</p>
              )}
            </div>
            <button
              type="button"
              onClick={() => onToggle(tool.id, !isEnabled)}
              className={`
                relative inline-flex h-6 w-11 items-center rounded-full transition-colors
                ${isEnabled ? 'bg-indigo-600' : 'bg-gray-200'}
              `}
            >
              <span className="sr-only">Enable {tool.name}</span>
              <span
                className={`
                  inline-block h-4 w-4 transform rounded-full bg-white transition-transform
                  ${isEnabled ? 'translate-x-6' : 'translate-x-1'}
                `}
              />
            </button>
          </div>
        );
      })}
    </div>
  );
}